// @flow
import React from 'react';
import {Box, makeStyles} from '@material-ui/core';
import SortableList from 'react-easy-sort';

import OptionGroupItem from './OptionGroupItem';

import type {ProductOptionGroup} from '../../../../../entities/product';
import {useStoreOptionActions} from './OptionsContext';

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));

type Props = {
  optionGroups: ProductOptionGroup[],
};

function OptionsList({optionGroups = []}: Props) {
  const classes = useStyles();

  const {orderGroups} = useStoreOptionActions();

  const handleSortEnd = (oldIndex: number, newIndex: number) => {
    if (oldIndex === newIndex) return;

    orderGroups(oldIndex, newIndex);
  };

  return (
    <Box className={classes.container}>
      <SortableList
        onSortEnd={handleSortEnd}
        className={classes.listContainer}
        draggedItemClassName="dragged"
        lockAxis="y"
      >
        {optionGroups.map(optionGroup => (
          <OptionGroupItem key={optionGroup.id} optionGroup={optionGroup} />
        ))}
      </SortableList>
    </Box>
  );
}

const MemoOptionsList = React.memo(OptionsList);

export default MemoOptionsList;
